import React from 'react'
import {
  SimpleForm,
  TextInput,
  SelectInput,
  NumberInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
} from 'react-admin'
import { Box, Typography } from '@mui/material'
import Edit from '../common/views/Edit'
import RichTextInput from '../common/inputs/RichTextInput'
import { campaignStatusChoices, sendMethodChoices } from './constants'

const userOptionText = (record) => record ? `${record.fullname || record.email} (${record.email})` : ''

const CampaignEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      {/* Status */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1' }}>
        Status
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <SelectInput
          source="status"
          label="Status"
          choices={campaignStatusChoices}
          fullWidth
        />
        <SelectInput
          source="default_send_method"
          label="Send Method"
          choices={sendMethodChoices}
          fullWidth
        />
      </Box>

      {/* General */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        General
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput
          source="name"
          label="Campaign Name"
          fullWidth
          validate={(value) => (!value ? 'Name is required' : undefined)}
        />
        <TextInput source="lemlist_campaign_id" label="Lemlist Campaign ID" fullWidth />
        <TextInput source="description" label="Description" fullWidth multiline rows="2" />
        <TextInput source="objectives" label="Objectives" fullWidth multiline rows="2" />
      </Box>

      {/* Messages */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        First Message
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput source="subject" label="Subject" fullWidth />
        <RichTextInput source="message" label="Message Body" />
      </Box>

      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Follow-up Message
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput source="followup_subject" label="Follow-up Subject" fullWidth />
        <RichTextInput source="followup_message" label="Follow-up Message Body" />
        <NumberInput source="followup_delay_days" label="Follow-up Delay (days)" fullWidth />
      </Box>

      {/* Settings */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Settings
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <ReferenceArrayInput reference="users" source="sender_user_ids">
          <AutocompleteArrayInput optionText={userOptionText} clearOnBlur={false} label="Senders" fullWidth />
        </ReferenceArrayInput>
        <NumberInput source="daily_limit" label="Daily Limit" fullWidth />
        <NumberInput source="send_hour_start" label="Send Hour Start" fullWidth />
        <NumberInput source="send_hour_end" label="Send Hour End" fullWidth />
      </Box>
    </SimpleForm>
  </Edit>
)

export default CampaignEdit
